import { render, staticRenderFns } from "./task_beta.vue?vue&type=template&id=7426b75a&scoped=true"
import script from "./task_beta.vue?vue&type=script&lang=ts"
export * from "./task_beta.vue?vue&type=script&lang=ts"
import style0 from "./task_beta.vue?vue&type=style&index=0&id=7426b75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7426b75a",
  null
  
)

export default component.exports